import apiBase from './apiBase';

class RentalApi {
  static attemptRide(bikeNumber, location) {
    return apiBase.create().post('/mobile/rides/attempt?api-version=2', {
      bikeNumber,
      location,
    });
  }

  static requestUnlockBike(rideId, location) {
    return apiBase.create().post(`/mobile/rides/${rideId}/requestBikeUnlocking`, {
      location,
    });
  }
}

export default RentalApi
